import React, { useEffect, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import CommonSelect from "../../../CommonMethhods/CommonSelect";
import BasicDetail from "./BasicDetail";
import PersonalDetails from "./PersonalDetails";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { AESEncryption, ApiResDecrypt } from "../../../CommonMethhods/CommonMethods";
import axios from "axios";
import { toast } from "react-toastify";
import NomineeDetails from "./NomineeDetails";
import BankDetails from "./BankDetails";
import BrokerageDetails from "./BrokerageDetails";
import SegmentDetails from "./SegmentDetails";
import { Modal } from "react-bootstrap";
import questionImg from "../../../asset/images/questionIcon.svg";

function IndividualDetailsAccordian(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [masterValue, setMasterVal] = useState({});
  const resumeVal = props.resumeVal;
  const resumeMobVal = resumeVal?.verificationDetails?.mobileNo;
  const resumeEmailVal = resumeVal?.verificationDetails?.email;
  const relation = props?.relation;
  const activeTab = props?.activeTab;
  const [finalModal, setFinalModal] = useState(false);
  const [showNominee, setShowNominee] = useState(false);

  const isUserValid = !!resumeMobVal && !!resumeEmailVal;
  const canAccessAccordion =
    (props.mobileVerify === true && props.emailVerify === true) ||
    isUserValid === true;

  const [activeAccordion, setActiveAccordion] = useState(
    canAccessAccordion ? "basic" : null
  );

  const basicDetails = resumeVal?.basicDetails || {};
  const personalDetails = resumeVal?.personalDetails || {};
  const nomineeDetails = resumeVal?.nomineeDetails || [];
  const bankDetails = resumeVal?.BankDetails || [];
  const brokerageDetails = resumeVal?.brokerageDetails || [];

  const overallPercentage = nomineeDetails.reduce((total, nominee) => {
    return total + (Number(nominee.percentage) || 0);
  }, 0);

  const isUserValidPersonalDetails =
    !!resumeMobVal && !!resumeEmailVal && !!basicDetails?.dob && !!basicDetails?.fullName && !!basicDetails?.pan;

  const isUserValidNomineeDetails =
    !!resumeMobVal && !!resumeEmailVal && !!basicDetails?.dob && !!basicDetails?.fullName && !!basicDetails?.pan &&
    !!personalDetails?.fatherName && !!personalDetails?.gender && !!personalDetails?.maritalStatus && !!personalDetails?.incomeRange &&
    !!personalDetails?.occupation && !!personalDetails?.bussinessType && personalDetails?.optForDDPI !== "" && personalDetails?.activateFNO !== "" &&
    !!personalDetails?.nationality && !!personalDetails?.residentialStatus && !!personalDetails?.typeOfAccount && !!personalDetails?.tradingPreferences &&
    !!personalDetails?.presentAddressLine1  && !!personalDetails?.presentAddressPinCode && !!personalDetails?.presentAddressCity &&
    !!personalDetails?.presentAddressState && personalDetails?.isPermanentAddrIsSameAsPresentAddr !== "" && !!personalDetails?.permanentAddressLine1  &&
    !!personalDetails?.permanentAddressPinCode && !!personalDetails?.permanentAddressCity && !!personalDetails?.permanentAddressState && personalDetails?.addNomineeDetails !== "" &&
    personalDetails?.netWorth !== "" && !!personalDetails?.tradingExperience && personalDetails?.isPoliticallyExposed !== "" && personalDetails?.pastActions !== "";

  const isUserValidBankDetails =
  !!resumeMobVal && !!resumeEmailVal && !!basicDetails?.dob && !!basicDetails?.fullName && !!basicDetails?.pan &&
    !!personalDetails?.fatherName && !!personalDetails?.gender && !!personalDetails?.maritalStatus && !!personalDetails?.incomeRange &&
    !!personalDetails?.occupation && !!personalDetails?.bussinessType && personalDetails?.optForDDPI !== "" && personalDetails?.activateFNO !== "" &&
    !!personalDetails?.nationality && !!personalDetails?.residentialStatus && !!personalDetails?.typeOfAccount && !!personalDetails?.tradingPreferences &&
    !!personalDetails?.presentAddressLine1  && !!personalDetails?.presentAddressPinCode && !!personalDetails?.presentAddressCity &&
    !!personalDetails?.presentAddressState && personalDetails?.isPermanentAddrIsSameAsPresentAddr !== "" && !!personalDetails?.permanentAddressLine1  &&
    !!personalDetails?.permanentAddressPinCode && !!personalDetails?.permanentAddressCity && !!personalDetails?.permanentAddressState && personalDetails?.addNomineeDetails !== "" &&
    personalDetails?.netWorth !== "" && !!personalDetails?.tradingExperience && personalDetails?.isPoliticallyExposed !== "" && personalDetails?.pastActions !== "" &&
  (personalDetails?.addNomineeDetails === true ? (nomineeDetails?.length > 0 
  && overallPercentage === 100) : personalDetails?.addNomineeDetails === false && (nomineeDetails?.length === 0 && overallPercentage === 0));

  console.log(personalDetails?.addNomineeDetails, nomineeDetails?.length, overallPercentage,  "personalDetails?.addNomineeDetails");
  
  const isValidBrokerage =
  !!resumeMobVal && !!resumeEmailVal && !!basicDetails?.dob && !!basicDetails?.fullName && !!basicDetails?.pan &&
    !!personalDetails?.fatherName && !!personalDetails?.gender && !!personalDetails?.maritalStatus && !!personalDetails?.incomeRange &&
    !!personalDetails?.occupation && !!personalDetails?.bussinessType && personalDetails?.optForDDPI !== "" && personalDetails?.activateFNO !== "" &&
    !!personalDetails?.nationality && !!personalDetails?.residentialStatus && !!personalDetails?.typeOfAccount && !!personalDetails?.tradingPreferences &&
    !!personalDetails?.presentAddressLine1  && !!personalDetails?.presentAddressPinCode && !!personalDetails?.presentAddressCity &&
    !!personalDetails?.presentAddressState && personalDetails?.isPermanentAddrIsSameAsPresentAddr !== "" && !!personalDetails?.permanentAddressLine1  &&
    !!personalDetails?.permanentAddressPinCode && !!personalDetails?.permanentAddressCity && !!personalDetails?.permanentAddressState && personalDetails?.addNomineeDetails !== "" &&
    personalDetails?.netWorth !== "" && !!personalDetails?.tradingExperience && personalDetails?.isPoliticallyExposed !== "" && personalDetails?.pastActions !== "" &&
  (personalDetails?.addNomineeDetails === true ? (nomineeDetails?.length > 0 
  && overallPercentage === 100) : (nomineeDetails?.length === 0 && overallPercentage === 0)) && bankDetails?.bankAcNo !== "" && bankDetails?.ifsccode !== "";

  const isValidSegment =
  !!resumeMobVal && !!resumeEmailVal && !!basicDetails?.dob && !!basicDetails?.fullName && !!basicDetails?.pan &&
    !!personalDetails?.fatherName && !!personalDetails?.gender && !!personalDetails?.maritalStatus && !!personalDetails?.incomeRange &&
    !!personalDetails?.occupation && !!personalDetails?.bussinessType && personalDetails?.optForDDPI !== "" && personalDetails?.activateFNO !== "" &&
    !!personalDetails?.nationality && !!personalDetails?.residentialStatus && !!personalDetails?.typeOfAccount && !!personalDetails?.tradingPreferences &&
    !!personalDetails?.presentAddressLine1  && !!personalDetails?.presentAddressPinCode && !!personalDetails?.presentAddressCity &&
    !!personalDetails?.presentAddressState && personalDetails?.isPermanentAddrIsSameAsPresentAddr !== "" && !!personalDetails?.permanentAddressLine1  &&
    !!personalDetails?.permanentAddressPinCode && !!personalDetails?.permanentAddressCity && !!personalDetails?.permanentAddressState && personalDetails?.addNomineeDetails !== "" &&
    personalDetails?.netWorth !== "" && !!personalDetails?.tradingExperience && personalDetails?.isPoliticallyExposed !== "" && personalDetails?.pastActions !== "" &&
  (personalDetails?.addNomineeDetails === true ? (nomineeDetails?.length > 0 
  && overallPercentage === 100) : (nomineeDetails?.length === 0 && overallPercentage === 0)) && bankDetails?.bankAcNo !== "" && bankDetails?.ifsccode !== "" && brokerageDetails?.delivery !== "" && brokerageDetails?.intraday !== "" && brokerageDetails?.futures !== "" 
  && brokerageDetails?.options !== "";
  
  const getMasterDetails = async () => {
    try {
      const getRelation = await axios.get(
        Lead_Creation.Select_Relation,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        setMasterVal(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitFinalStatus = async (status) => {
    let payloadValue = {
              isSubmitted: status,
              refId: resumeVal?.id
            };
            let encPayload = AESEncryption(payloadValue);

    try {
      const getRelation = await axios.post(
        Lead_Creation.Final_Status,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getRelation?.data);
        console.log(res, "statusResponse");

      if (res?.status === 0) {
         toast.success(res?.data)
        setFinalModal(false);
      } else {
        setFinalModal(false);
        console.log(res?.message);
        
        // toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const isValidResume = !!resumeVal?.verificationDetails?.mobileNo && !!resumeVal?.verificationDetails?.email;
  
    if (!isValidResume) {
      setActiveAccordion(null);
    }
  }, [resumeVal]);

  useEffect(() => {
    getMasterDetails();
  }, []);

  useEffect(()=>{
    // if(isValidSegment === true){
    //   setActiveAccordion(null)
    // }
    if(canAccessAccordion === true &&
      isUserValidPersonalDetails === true &&
      isUserValidNomineeDetails === true &&
      isUserValidBankDetails === true &&
      isValidBrokerage === true &&
      isValidSegment === true && resumeVal?.segmentActivationDetails?.docName !== ""){
        setFinalModal(true);
      }
  }, [isValidSegment, resumeVal?.segmentActivationDetails?.docName]);

  console.log(resumeVal, "resumeVal90099");
  

  const nomineeAccordian =(value)=>{
    setShowNominee(value)
  }

  const handleStatus=(status)=>{
    submitFinalStatus(status)
  }

  return (
    <>
    <div
      className="tab-content refer-tab-content individual-acc-accordian"
      id="knowledgeTabContent"
    >
      <div
        className="tab-pane fade show active"
        id="module-tab-pane"
        role="tabpanel"
        aria-labelledby="module-tab"
        tabIndex={0}
      >
        <div className="accordion" id="accordionKnowledge">
          <div className="accordion-item">
            <h2 
            className="accordion-header" 
            id="headingOne"
            onClick={() => {
              if (!canAccessAccordion) return;
              setActiveAccordion(
                activeAccordion === "basic" ? null : "basic"
              );
            }}
            style={{
              cursor: canAccessAccordion ? "pointer" : "not-allowed"
            }}
            >
              <button
                className={`accordion-button ${
                  activeAccordion === "basic" ? "" : "collapsed"
                }`}
                type="button"
                // onClick={() => {
                //   if (!canAccessAccordion) return;
                //   setActiveAccordion(
                //     activeAccordion === "basic" ? null : "basic"
                //   );
                // }}
                aria-expanded={activeAccordion === "basic"}
                aria-controls="collapseOne"
                disabled={!canAccessAccordion}
              >
                Basic Details
              </button>
            </h2>
            <div
              id="collapseOne"
              className={`accordion-collapse collapse ${
                activeAccordion === "basic" ? "show" : ""
              }`}
              aria-labelledby="headingOne"
              // data-parent="#accordionKnowledge"
            >
              <div className="accordion-body">
                <BasicDetail resumeVal={resumeVal} activeTab={activeTab}/>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" 
            id="headingTwo"
            onClick={() => {
              if (!isUserValidPersonalDetails) return;
              setActiveAccordion(
                activeAccordion === "personal" ? null : "personal"
              );
            }}
            style={{
              cursor: isUserValidPersonalDetails ? "pointer" : "not-allowed"
            }}
            >
              <button
                className={`accordion-button ${
                  activeAccordion === "personal" ? "" : "collapsed"
                }`}
                type="button"
                aria-controls="collapseTwo"
                // onClick={() => {
                //   if (!isUserValidPersonalDetails) return;
                //   setActiveAccordion(
                //     activeAccordion === "personal" ? null : "personal"
                //   );
                // }}
                disabled={!isUserValidPersonalDetails}
                aria-expanded={activeAccordion === "personal"}
                
              >
                Personal Details
              </button>
            </h2>

            <div
              id="collapseTwo"
              className={`accordion-collapse collapse ${
                activeAccordion === "personal" ? "show" : ""
              }`}
              aria-labelledby="headingTwo"
            >
              <div className="accordion-body">
                <PersonalDetails
                  resumeVal={resumeVal}
                  masterValue={masterValue}
                  showNom={nomineeAccordian}
                  activeTab={activeTab}
                />
              </div>
            </div>
          </div>
          {console.log(showNominee, "showNominee")
          }
          {showNominee === true &&
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree"
            
            onClick={() => {
              if (!isUserValidNomineeDetails) return;
              setActiveAccordion(
                activeAccordion === "nominee" ? null : "nominee"
              );
            }}
            style={{
              cursor: isUserValidNomineeDetails ? "pointer" : "not-allowed"
            }}
            
            >
                <button
                  className={`accordion-button ${
                    activeAccordion === "nominee" ? "" : "collapsed"
                  }`}
                  type="button"
                  data-toggle="collapse"
                  // data-target="#collapseThree"
                  // aria-controls="collapseThree"
                  // onClick={() => {
                  //   if (!isUserValidNomineeDetails) return;
                  //   setActiveAccordion(
                  //     activeAccordion === "nominee" ? null : "nominee"
                  //   );
                  // }}
                  disabled={!isUserValidNomineeDetails}
                  aria-expanded={activeAccordion === "nominee"}
                >
                  Nominee Details
                  <span className="gray-text" style={{ color: "#9E9E9E", fontSize: "12px" }}> (You can add upto 3 nominees)</span>
                </button>
              </h2>
              <div
                id="collapseThree"
                className={`accordion-collapse collapse ${
                  activeAccordion === "nominee" ? "show" : ""
                }`}
                aria-labelledby="headingThree"
                data-parent="#accordionKnowledge"
              >
                <div className="accordion-body">
                  <NomineeDetails
                    resumeVal={resumeVal}
                    masterValue={masterValue}
                    relation={relation}
                    activeTab={activeTab}
                    showNominee={true}
                  />
                </div>
              </div>
            </div>
          }
          <div className="accordion-item">
            <h2 className="accordion-header" 
              id="headingFour"
              onClick={() => {
                if (!isUserValidBankDetails) return;
                setActiveAccordion(
                  activeAccordion === "bank" ? null : "bank"
                );
              }}
              style={{
                cursor: isUserValidBankDetails ? "pointer" : "not-allowed"
              }}
            >

              <button
                className={`accordion-button ${
                  activeAccordion === "bank" ? "" : "collapsed"
                }`}
                type="button"
                data-toggle="collapse"
                // data-target="#collapseFour"
                // aria-controls="collapseFour"
                disabled={!isUserValidBankDetails}
                aria-expanded={activeAccordion === "bank"}
              >
                Bank Details
              </button>
            </h2>
            <div
              id="collapseFour"
              className={`accordion-collapse collapse ${
                activeAccordion === "bank" ? "show" : ""
              }`}
              aria-labelledby="headingFour"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body">
                <BankDetails resumeVal={resumeVal}
                  masterValue={masterValue}
                  activeTab={activeTab}
                  />
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" 
            id="headingFive"
            onClick={() => {
              if (!isValidBrokerage) return;
              setActiveAccordion(
                activeAccordion === "brokerage" ? null : "brokerage"
              );
            }}
            style={{
              cursor: isValidBrokerage ? "pointer" : "not-allowed"
            }}
            >
              <button
                className={`accordion-button ${
                  activeAccordion === "brokerage" ? "" : "collapsed"
                }`}
                type="button"
                data-toggle="collapse"
                // data-target="#collapseFive"
                // aria-controls="collapseFive"
                onClick={() => {
                  if (!isValidBrokerage) return;
                  setActiveAccordion(
                    activeAccordion === "brokerage" ? null : "brokerage"
                  );
                }}
                aria-expanded={activeAccordion === "brokerage"}
                disabled={!isValidBrokerage}
              >
                Brokerage Details
              </button>
            </h2>
            <div
              id="collapseFive"
              className={`accordion-collapse collapse ${
                activeAccordion === "brokerage" ? "show" : ""
              }`}
              aria-labelledby="headingFive"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body ">
                <BrokerageDetails resumeVal={resumeVal}
                  masterValue={masterValue}
                  activeTab={activeTab}
                  />
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" 
            id="headingSix"
            onClick={() => {
              if (!isValidSegment) return;
              setActiveAccordion(
                activeAccordion === "segment" ? null : "segment"
              );
            }}
            style={{
              cursor: isValidSegment ? "pointer" : "not-allowed"
            }}
            >
              <button
                className={`accordion-button ${
                  activeAccordion === "segment" ? "" : "collapsed"
                }`}
                type="button"
                data-toggle="collapse"
                // data-target="#collapseSix"
                // aria-controls="collapseSix"
                // onClick={() => isValidSegment && setActiveAccordion("segment")}
                onClick={() => {
                  if (!isValidSegment) return;
                  setActiveAccordion(
                    activeAccordion === "segment" ? null : "segment"
                  );
                }}
                aria-expanded={activeAccordion === "segment"}
                disabled={!isValidSegment}
              >
                Segment Activation
              </button>
            </h2>
            <div
              id="collapseSix"
              className={`accordion-collapse collapse ${
                activeAccordion === "segment" ? "show" : ""
              }`}
              aria-labelledby="headingSix"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body ">
                <SegmentDetails 
                  resumeVal={resumeVal}
                  masterValue={masterValue}
                  activeTab={activeTab}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
    show={finalModal}
    onHide={()=>setFinalModal(false)}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    className="setting-model ifsc-Modal bank-verify-modal individual-modal final-modal"
    backdrop="static"
    keyboard={false}
    >
    <button
      type="button"
      className="btn-close ifsc-modal-btn"
      aria-label="Close"
      onClick={()=>setFinalModal(false)}
    >
      <span className="icon-close"></span>
    </button>
    <Modal.Header className="modal-header ifsc-modal-header">
      <Modal.Title id="contained-modal-title-vcenter modal-title">
        <span>
          <img src={questionImg} alt="questionIcon"/>
          </span>
        <p className="final-modal-title">Do you wish to save all the details?</p>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="nominee-btn-wrapper nominee-wrap-sec">

      <div
            className="wrap-button"
          >
            <button
              type="button"
              className="val-btn-nom cancel-btn"
              onClick={()=>handleStatus(false)}
            >
              Cancel
            </button>
            </div>
      <div className="wrap-button">
        <button type="submit" className="val-btn-wrap"
          onClick={()=>handleStatus(true)}>
          Save and Proceed
        </button>
      </div>
      </div>
    </Modal.Body>
    </Modal>
    </>
  );
}

export default IndividualDetailsAccordian;
